import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import {updateOffscreenPanelVisibility} from '../utils/a11y';

export default register('announcement', {
  onLoad() {
    this.isAnimated = false;

    const announcementSlider = this.container.querySelector('.announcement__slider');
    if (!announcementSlider) return;
    const announcementSlides = [...announcementSlider.querySelectorAll('.announcement__text')];
    if (announcementSlider) {
      this.announcementSlider = new Flickity(announcementSlider, {
        autoPlay: true,
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'center',
        watchCSS: true,
        wrapAround: true,
        pauseAutoPlayOnHover: true,
        on: {
          ready() {
            updateOffscreenPanelVisibility(announcementSlides);
          },
          change() {
            updateOffscreenPanelVisibility(announcementSlides);
          },
        },
      });
    }

    this.handleMarqueeAnimation.apply(this);

    window.addEventListener('resize', this.handleMarqueeAnimation.bind(this));
  },

  handleMarqueeAnimation() {
    const wrapper = this.container.querySelector('.announcement__wrap');
    const textWrapper = this.container.querySelector('.announcement__text-wrap');
    const textWidth = textWrapper.scrollWidth;

    if (wrapper) {
      // Activate marquee when text width is bigger than window width
      if (textWidth > window.innerWidth) {
        // Check if animation is already activated
        if (!this.isAnimated) {
          const clone = textWrapper.cloneNode(true);
          clone.ariaHidden = true;
          updateOffscreenPanelVisibility([clone]);
          wrapper.appendChild(clone);
          wrapper.style.width = `${textWidth * 2}px`;
          this.container.classList.add('marquee');
          this.isAnimated = true;
        }
        // Check if animation is already deactivated
      } else if (this.isAnimated) {
        wrapper.removeChild(wrapper.lastElementChild);
        wrapper.removeAttribute('style');
        this.container.classList.remove('marquee');
        this.isAnimated = false;
      }
    }
  },
});
